// Korean
export const ko = {
    weeklyRewards: '주간 보상까지',
    days: '일',
    hours: '시간',
    minutes: '분',
    seconds: '초',
    authenticating: '인증 중',
    verifyWallet: '지갑을 확인하는 동안 기다려주세요',
    authRequired: '인증이 필요합니다',
    authFailed: '인증에 실패했습니다. 다시 시도해주세요.',
    points: '포인트',
    rank: '순위',
    of: '/',
    players: '플레이어',
    weeklyTopPlayers: '이번 주 상위 플레이어',
    thisWeekLeaderboard: '이번 주 리더보드',
    rankingsReset: '순위는 매주 일요일 UTC 자정에 초기화됩니다',
    yourPoints: '내 포인트',
    dailyRewardAvailable: '일일 보상이 가능합니다!',
    nextClaimAvailable: '다음 수령까지:',
    claimDailyReward: '일일 보상 받기',
    claiming: '수령 중...',
    multiplier: '배율',
    bonusPointsMultiplier: '보너스 포인트 배율',
    outOf: '/',
    loading: '로딩 중...',
    errorLoading: '로딩 오류',
    noEntries: '항목 없음',
    leaderboard: '리더보드',
    tasks: '작업',
    rules: '규칙',
    profile: '프로필',
    comingSoon: '곧 출시...',
    completedTasks: '완료된 작업',
    dailyRewardsClaimed: '수령한 일일 보상',
    times: '회',
    recentActivity: '최근 활동',
    noRewardsClaimed: '아직 수령한 보상이 없습니다',
    dailyReward: '일일 보상',
    howItWorks: '이용 방법',
    welcomeMessage:
        'Coinomi Rewards에 오신 것을 환영합니다! 다양한 작업을 완료하여 포인트를 획득하고 순위를 올려보세요.',
    dailyRewardsTitle: '일일 보상',
    dailyRewardsRules: [
        '24시간마다 일일 보상을 받을 수 있습니다',
        '각 수령 시 100포인트 획득',
        '포인트는 배율에 따라 증가합니다',
    ],
    multiplierBonusesTitle: '배율 보너스',
    multiplierBonusesRules: [
        '1배율로 시작',
        'Telegram 연동으로 +10% 보너스',
        '이메일 인증으로 +10% 보너스',
        '보너스는 최대 보상을 위해 누적됩니다',
    ],
    leaderboardTitle: '리더보드',
    leaderboardRules: [
        '다른 플레이어와 경쟁',
        '리더보드는 실시간으로 업데이트',
        '상위 플레이어는 특별 보상을 받습니다',
    ],
    boostEarningsTitle: '수익 증가',
    boostEarningsRules: [
        '도전 과제를 완료하여 보너스 획득',
        'Telegram 커뮤니티에 참여',
        '최대 보상을 위해 활성 상태 유지',
    ],
    challenges: '도전 과제',
    telegramChallenge: 'Telegram 도전',
    emailChallenge: '이메일 도전',
    connectTelegram: 'Telegram 연동',
    shareEmail: '이메일 공유',
    telegramSuccess: '🎉 축하합니다! 이제 모든 보상에 대해 영구적인 10% 보너스를 받게 됩니다!',
    telegramPrompt: 'Telegram 계정을 연동하여 모든 보상에 대해 영구적인 10% 보너스를 받으세요!',
    emailSuccess: '🎉 축하합니다! 이제 모든 보상에 대해 영구적인 10% 보너스를 받게 됩니다!',
    emailPrompt: '이메일을 공유하여 모든 보상에 대해 영구적인 10% 보너스를 받으세요!',
    connectEmail: '이메일 연동',
    cancel: '취소',
    emailPrivacy: '귀하의 이메일은 중요한 업데이트와 보상 알림에만 사용됩니다.',
    connectYourEmail: '이메일 연동하기',
    emailBonus: '🎉 이메일을 연동하여 모든 보상에 대해 영구적인 10% 보너스를 받으세요!',
    enterValidEmail: '유효한 이메일 주소를 입력해주세요',
    emailAddress: '이메일 주소',
    errorSavingEmail: '이메일 저장 중 오류가 발생했습니다. 다시 시도해주세요.',
    claimButton: '받기',
    earnedReward: '획득한 보상',
    rewardValue: '{{amount}} 포인트',
    claimingReward: '수령 중...',
    claimSuccess: '{{amount}} 포인트를 성공적으로 받았습니다!',
    claimError: '수령에 실패했습니다. 다시 시도해주세요.',
    privacyDisclaimer:
        'Coinomi는 개인 데이터를 수집하지 않습니다. 제3자 시스템이 포인트와 소셜 연결을 안전하게 관리합니다.',
    streakBonus: '연속 보너스',
    streakDays: '{{days}}/5일',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% 추가',
    streakDescription: '최대 보너스를 위해 5일 연속으로 받으세요',
    streakToday: '오늘',
    streakMissed: '놓침',
    streakComplete: '완료',
    streakActive: '활성 연속',
    streakLost: '연속 실패',
    streakNext: '다음',
    home: '홈',
    currentStreak: '현재 연속',
    totalClaims: '총 수령 횟수',
    userStats: '내 통계',
    referrals: '추천',
    referralProgram: '추천 프로그램',
    howReferralWorks: '추천 방법:',
    referralSteps: [
        '친구와 추천 링크 공유',
        '귀하의 링크로 가입하면 추천인이 됩니다',
        '활성 추천마다 보너스 포인트 획득',
        '여기서 추천과 수익을 확인하세요',
    ],
    referralRewards: '추천 포인트 지급:',
    referralBonuses: ['추천당 100포인트', '추천인이 획득한 모든 포인트의 10%'],
    yourReferralLink: '내 추천 링크',
    copyToClipboard: '클립보드에 복사',
    linkCopied: '링크가 클립보드에 복사되었습니다!',
    totalReferrals: '총 추천 수',
    yourReferralCode: '내 추천 코드',
    referralCodeCopied: '추천 코드가 복사되었습니다!',
    editReferralCode: '추천 코드 수정',
    editReferralCodeInstructions:
        '새 추천 코드를 선택하세요. 최소 5자 이상이어야 하며 문자와 숫자를 포함할 수 있습니다.',
    newReferralCode: '새 추천 코드',
    referralCodeRequirements: '최소 5자, 문자와 숫자만',
    updating: '업데이트 중...',
    update: '업데이트',
    referralCodeTaken: '이 추천 코드는 이미 사용 중입니다',
    haveReferralCode: '추천 코드가 있으신가요?',
    enterReferralCodePrompt:
        '누군가가 귀하를 추천했다면, 계정을 연결하기 위해 여기에 코드를 입력하세요.',
    enterReferralCode: '추천 코드 입력',
    enterReferralCodeInstructions: '공유받은 추천 코드를 입력하세요.',
    referralCode: '추천 코드',
    referralCodeFormat: '문자와 숫자만',
    submitting: '제출 중...',
    submit: '제출',
    enterCode: '코드 입력',
    pleaseAddtoken: 'URL에 토큰 매개변수를 추가해주세요',
    authenticationError: '인증 중 오류가 발생했습니다',
    noUserFound: '사용자를 찾을 수 없습니다',
    userNotFoundMessage: '사용자 데이터를 찾을 수 없습니다',
    backToHome: '홈으로 돌아가기',
    retry: '다시 시도',
    baseMultiplier: '기본 배율',
    telegramBonus: 'Telegram 보너스',
    referralChallenge: '추천 도전',
    referralChallengePrompt:
        '친구를 초대하고 보너스 포인트를 획득하세요! 추천당 100포인트와 그들의 수익의 10%를 받습니다.',
    startReferring: '추천 시작하기',
    referralSuccess:
        '🎉 축하합니다! 성공적으로 사용자를 추천하고 보너스 포인트를 획득하고 있습니다!',
    unranked: '순위 없음',
    noPlayersYet: '첫 번째 참가자가 되어보세요!',
    shareVia: '공유 방법',
    shareOn: '{{network}}에서 공유',
    shareInviteText:
        '🚀 @CoinomiWallet으로 무료 암호화폐를 벌고 있습니다!\n\ncoinomi.com/downloads에서 Coinomi를 다운로드하고 앱에서 #Coinomi Rewards에 가입할 때 내 추천 코드 {{referralCode}}를 입력하여 보너스를 받으세요.',
    yourStatsThisWeek: '이번 주 통계',
    pointsMultiplier: '포인트 배율',
    yourRank: '내 순위',
    rewards: '보상',
    daily: '일일',
    weekly: '주간',
    claimRewards: '보상 받기',
    player: '플레이어',
    score: '점수',
    youHaveReferred_zero: '아직 초대한 친구가 없습니다',
    youHaveReferred_one: '1명의 친구를 초대했습니다',
    youHaveReferred_other: '{{count}}명의 친구를 초대했습니다',
    referYourFriends: '친구 초대하기',
    dailyRewardTooltip: '매일 접속하여 포인트와 보상을 받으세요',
    weeklyRewardTooltip: '보상은 주간 단위로 지급됩니다',
    copy: '복사',
    // Twitter Challenge
    twitterChallenge: '트위터 챌린지',
    connectTwitter: '트위터 연결',
    twitterSuccess: '🎉 축하합니다! 이제 모든 보상에 10% 영구 보너스를 받게 됩니다!',
    twitterPrompt: '트위터 계정을 연결하여 모든 보상에 10% 영구 보너스를 받으세요!',
    pleaseAddUserId: 'URL에 userId 매개변수를 추가해주세요',
    emailChallengePrompt: '이메일을 공유하여 모든 보상에 대해 영구적인 10% 보너스를 받으세요!',
    emailChallengeSuccess:
        '🎉 연결되었습니다! 이제 모든 보상에 대해 영구적인 10% 보너스를 받게 됩니다!',
    followKoalaWalletChallenge: '@coinomiWallet를 트위터에서 팔로우하여 저희를 응원해주세요!',
    twitterAuthSuccessTitle: '트위터가 성공적으로 연결되었습니다!',
    twitterAuthSuccessMessage:
        '트위터 계정이 성공적으로 연결되었습니다. 이제 앱을 계속 사용할 수 있습니다.',
    continueToApp: '앱으로 계속하기',
    twitter_like: '트윗을 좋아요함',
    twitter_retweet: '트윗을 리트윗함',
    disconnect: '연결 해제',
    followCoinomiWallet: '트위터에서 @coinomiWallet을 팔로우하여 저희를 응원해주세요!',
    connectedBonus: '🎉 연결됨! 이제 모든 보상에 대해 영구적인 10% 보너스를 받게 됩니다!',
};
